import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import TagManagerService from 'services/TagManager';
import style from './style.scss'; //NOSONAR
import { ecommerce } from 'config/constants';

const Video = (props) => {

    const data = props.data ? props.data : null;
    // const date = props.date ? props.date : null;
    // const validateDates = props.validateDates ? props.validateDates : null;
    
    if(!data) return '';
    

    const getElement = (content) => {
        return content.map((item) => {
            if(!item.active) return false;
            return item
        }).filter(Boolean);
    }

    const items = getElement(data.content);

    useEffect(() => {
        promotionView();
    }, []);

    const _getVideo = (idVideo, play = false) => {
        const autoPlay = play ? '1' : '0';
        return `https://www.youtube.com/embed/${idVideo}?autoplay=${autoPlay}`;
    }

    const promotionView = () => {
        const promoVideo = items.map((item, i) => {
            return {
                id: item ? item.title : 'Video Offers',
                name: item ? item.title : 'Video Offers',
                position: 'slot' + (i + 1),
                creative: 'Vitrina Video' 
            }
        })
            
        TagManagerService.promotionsImpressions(promoVideo);
    }

    const promotionClick = (item, index) => {
        const clickVideo = {
            url_banner: item.url,
            id: item ? item.title : 'Video Offers',
            name: item ? item.title : 'Video Offers',
            position: 'slot' + (index + 1),
            creative: 'Vitrina Video'
        }

        TagManagerService.promotionsClick(clickVideo);
        
    }

    if(!items.length) return ''; 

    return (
        <section className={'video-section' + ((items.length === 1)? ' video-container' : '')} >
            {items.map((item, index) =>  <div className={'video-wrapper' + ( items.length > 1 ? ' video-item' : '')} key={index} >
                <h1 className="video-title">{item.title}</h1>
                <div className="video-iframe-container" onClick={() => promotionClick(item, index)}>
                    <iframe src={_getVideo(item.id_video, item.autoplay)} 
                        frameBorder='0'
                        className="video-iframe"
                        allow='autoplay; encrypted-media'
                        allowFullScreen
                        title={ecommerce.metaTitle}
                    />
                </div>
            </div>)}
        </section>
    )
}

Video.propTypes = {
    data: PropTypes.object,
    date: PropTypes.number,
    validateDates: PropTypes.func
};


export default Video;
